module.exports = __webpack_public_path__ + "img/qr_code_ibmp.2dedb07b.png";